export default "__VITE_ASSET__CojBOZmk__"